module.exports = __webpack_public_path__ + "img/flag.301b7e0e.svg";